import type { SubmissionStatus } from "../types/MainType.type";
import { searchApplications } from "./genericFormServices";
import { API_BASE_URL } from "./NetworkService";

// 1. Search Query Parameters DTO
export interface SearchDocumentParams {
  fromDate?: string;
  toDate?: string;
  documentNumber?: string;
  officeId?: string;
  status?: SubmissionStatus | '';
  personName?: string;
  lawSection?: string;
  formType?: string;
  searchTerm?: string;
  currentPage?: number;
  itemsPerPage?: number;
}

// 2. Normalized Response Type for UI Display
export interface DocumentSearchResult {
  id: string;
  documentNumber: string;
  formType: string;
  status: SubmissionStatus;
  createdAt: string;
  originOfficeName?: string;
  complainantOrPlaintiff?: string;
  accusedOrDefendant?: string;
  lawSection?: string;
  raw: any; // Retains full backend payload
}

// 3. Mapper Function: Normalizes nested child forms into flat properties
const mapDocumentResponse = (item: any): DocumentSearchResult => {
  const plo = item.ploFormOne;
  const ploTwo = item.ploFormTwo;
  const laOne = item.legalAdviceFormOne;
  const laThree = item.legalAdviceFormThree;

  return {
    id: item.id,
    documentNumber:
      item.documentNumber ||
      laOne?.letterNo ||
      laThree?.regNo ||
      plo?.caseNumber ||
      ploTwo?.caseNumber ||
      '-',
    formType: item.formType,
    status: item.status,
    createdAt: item.createdAt,
    originOfficeName: item.originOffice?.name || '-',
    complainantOrPlaintiff:
      laOne?.complainant ||
      laThree?.plaintiffName ||
      plo?.plaintiffOrAccused ||
      ploTwo?.plaintiffOrAccused || 
      '-',
    accusedOrDefendant:
      laOne?.accused ||
      laThree?.defendantNameAndNrc ||
      plo?.plaintiffOrAccused ||
      ploTwo?.plaintiffOrAccused || 
      '-',
    lawSection:
      laOne?.lawSection ||
      laThree?.chargeSectionAndDate ||
      plo?.chargeSection ||
      ploTwo?.chargeSection || 
      '-',
    raw: item,
  };
};

// 4. Main Exported Search Function
export const searchDocuments = async (params: SearchDocumentParams) => {
  return searchApplications<DocumentSearchResult>(
    'documents/search',
    params,
    mapDocumentResponse
  );
};



// Simple direct open for viewing (No Blob/Token needed because of @SetMetadata('isPublic', true))
export const openFileInNewTab = (fileUrlOrName: string) => {
  if (!fileUrlOrName) return;

  // Extracts filename (e.g. '/uploads/file-123.pdf' -> 'file-123.pdf')
  const filename = fileUrlOrName.split('/').pop();

  // Constructs the correct NestJS route: /documents/view/:filename
  const targetUrl = `${API_BASE_URL}/uploads/${filename}`;

  // Opens directly in browser tab
  window.open(targetUrl, '_blank', 'noopener,noreferrer');
};